if(window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('\x43\x68\x72\x6F\x6D\x65\x2D\x4C\x69\x67\x68\x74\x68\x6F\x75\x73\x65') == -1 ) {function copycoupon1() {var text = document.getElementById('couponcode1');var copy = document.getElementById('copycode1');text.select();document.execCommand("copy");copy.focus();$('.code_coye_pop').addClass('show_pop_code');$('.share-window-cover').addClass('show-code-popup');$('.code_change').html(text.value);}function copycoupon2() {var text = document.getElementById('couponcode2');var copy = document.getElementById('copycode2');text.select();document.execCommand("copy");copy.focus();$('.code_coye_pop').addClass('show_pop_code');$('.share-window-cover').addClass('show-code-popup');$('.code_change').html(text.value);}function closecodepop() {if ($('.share-window-cover').hasClass('show-code-popup')) {$('.share-window-cover').removeClass('show-code-popup');$('.code_coye_pop').removeClass('show_pop_code');}}

function copycoupon3() {
    var text = document.getElementById('couponcode3');
    var copy = document.getElementById('copycode3');
    text.select();
    document.execCommand("copy");
    copy.focus();
    $('.code_coye_pop').addClass('show_pop_code');
    $('.share-window-cover').addClass('show-code-popup');
    $('.code_change').html(text.value);
}


var product_id = $("#s_product_id").text();
var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;//浏览器兼容
var config = { attributes: true, childList: true}//配置对象
var varint_price = 0;        

		$("#ProductPrice-"+product_id).each(function(){
          
		   var _this = $(this);
		   var observer = new MutationObserver(function(mutations) {//构造函数回调
			  mutations.forEach(function(record) {
				 if(record.type == "attributes" || record.type == 'childList'){//监听属性
                    varint_price = record.target.innerText
                    price1 = varint_price.replace("$","")
                    price2 = price1.replace("USD","")
                   	$("#varint_price").html("$"+(price2/4).toFixed(2))
				 }
                
			  });
		   });
		   observer.observe(_this[0], config);
		});

function klarna_popup(){

   $('.code_coye_pop1').addClass('show_pop_code1');
   $('.share-window-cover1').addClass('show-code-popup1');
  
}

function closecodepop1() {
    if ($('.share-window-cover1').hasClass('show-code-popup1')) {
        $('.share-window-cover1').removeClass('show-code-popup1');
        $('.code_coye_pop1').removeClass('show_pop_code1');
    }
}






}
